import React from 'react';
import { translate } from 'react-i18next';

import AccountNavItem from 'components/account/AccountNavItem';

class AccountNav extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activePage: this.props.activePage,
      advancedCalloutOptions: false,
      multiFormatNotificationsEnabled: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      advancedCalloutOptions: nextProps.advancedCalloutOptions,
      multiFormatNotificationsEnabled: nextProps.multiFormatNotificationsEnabled,
    });
  }

  passwordEdit() {
    if (window.EmployeeWeb.ENVConfig.brand === 'adp') {
      return '';
    }
    const user = Utils.getCoreUser();
    if (user && user.auth_method === 'makeshift') {
      return (
        <AccountNavItem
          onClickHandler={this.props.onClickHandler.bind(this)}
          activePage={this.props.activePage}
          section="password"
          text={this.props.t('AccountNav.password')}
        />
      );
    }
  }

  helpAndSupport() {
    if (window.EmployeeWeb.ENVConfig.brand !== 'makeshift') {
      return '';
    }
    return (
      <AccountNavItem
        onClickHandler={this.props.onClickHandler.bind(this)}
        activePage={this.props.activePage}
        section="help"
        text={this.props.t('AccountNav.help_and_support')}
      />
    );
  }

  render() {
    const isActive = this.state.activeState === this.state.activePage ? 'active' : 'default';

    return (
      <div>
        <nav className="secondary-nav">
          <h2>{this.props.t('AccountNav.basic_information')}</h2>
          <ul>
            <AccountNavItem
              onClickHandler={this.props.onClickHandler.bind(this)}
              activePage={this.props.activePage}
              section="contact"
              text={this.props.t('AccountNav.contact_info')}
            />
            {this.passwordEdit()}
            <AccountNavItem
              shouldRender={
                this.state.advancedCalloutOptions || this.state.multiFormatNotificationsEnabled
              }
              onClickHandler={this.props.onClickHandler.bind(this)}
              activePage={this.props.activePage}
              section="preferences"
              text={this.props.t('AccountNav.notifications')}
            />
            <AccountNavItem
              onClickHandler={this.props.onClickHandler.bind(this)}
              activePage={this.props.activePage}
              section="settings"
              text={this.props.t('AccountNav.settings')}
            />
          </ul>
        </nav>
        <nav className="secondary-nav">
          <h2>{this.props.t('AccountNav.extras')}</h2>
          <ul>
            <AccountNavItem
              onClickHandler={this.props.onClickHandler.bind(this)}
              activePage={this.props.activePage}
              section="calendar"
              text={this.props.t('AccountNav.calendar_sync')}
            />
            <AccountNavItem
              onClickHandler={this.props.onClickHandler.bind(this)}
              activePage={this.props.activePage}
              section="mobile"
              text={this.props.t('AccountNav.mobile_apps')}
            />
            {this.helpAndSupport()}
          </ul>
        </nav>
      </div>
    );
  }
}

export default translate()(AccountNav);
